export default __webpack_public_path__ + "static/media/newFile-12.57c1fffe.jpg";